import React from 'react'
import './style.css'

const AgendaTitle = ({ agenda }) => (
  <div className="AgendaTitle">
    <h2 title={`Agenda ID: ${agenda.id}`}>{agenda.professional.fullName}</h2>
    <h4>{agenda.office.officeName}</h4>
  </div>
)

export default AgendaTitle



// WEBPACK FOOTER //
// ./src/components/AgendaTitle/index.js